<mat-dialog-content>
  <h3>Custom Range</h3>
</mat-dialog-content>

<mat-divider></mat-divider>

<form [formGroup]="customIntervalForm">
  <mat-form-field appearance="fill" style="width: 100%">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate placeholder="Start date" formControlName="dateFrom" />
      <input matEndDate placeholder="End date" formControlName="dateTo" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <div class="modal-footer">
    <mat-dialog-actions>
      <button type="submit" [disabled]="!customIntervalForm.valid" (click)="saveInterval()" mat-button class="hover-color">
        Submit
      </button>
    </mat-dialog-actions>
  </div>
</form>
